if (!customElements.get('melokea-amazon-variants')) {
 customElements.define('melokea-amazon-variants', class extends HTMLElement {
  connectedCallback() {
   if (this.eventsConnected) return;
   this.eventsConnected = true;
   this.navigating = false;
   this.connectionVersion = (this.connectionVersion || 0) + 1;
   this.section = this.closest('[data-product-featured]') || this.closest('.shopify-section') || document;
   this.readSelected = () => this.section.querySelector('form[action*="/cart/add"] [name="id"]') || this.section.querySelector('[name="id"]');
   this.queueSync = (id) => {
    if (id) this.pendingVariantId = String(id);
    if (this.syncQueued) return;
    this.syncQueued = true;
    const version = this.connectionVersion;
    this.syncTimer = window.setTimeout(() => {
     if (version !== this.connectionVersion || !this.eventsConnected || !this.isConnected) return;
     this.syncTimer = null;
     this.syncQueued = false;
     this.bindTheme();
     const selected = this.readSelected();
     const selectedId = selected?.value || this.pendingVariantId;
     this.pendingVariantId = null;
     if (selectedId) {
      this.dataset.lastSyncId = String(selectedId);
      this.select(String(selectedId));
     }
    }, 0);
   };
   this.onChange = (event) => {
    if (event.target.name !== 'id' || !this.section.contains(event.target)) return;
    this.dataset.lastEvent = 'native-change';
    this.dataset.lastEventId = String(event.target.value || '');
    this.queueSync(event.target.value);
   };
   this.onSwatchClick = (event) => {
    const swatch = event.target.closest?.('[data-swatch-item]');
    if (!swatch || !this.section.contains(swatch)) return;
    this.dataset.lastEvent = 'swatch-click';
    this.dataset.lastEventId = String(this.readSelected()?.value || '');
    this.bindTheme();
    this.queueSync();
   };
   this.onThemeChange = (event, variant) => {
    const id = event.currentVariant?.id || variant?.id || event.detail?.variant?.id;
    this.dataset.lastEvent = 'theme-variant';
    this.dataset.lastEventId = String(id || '');
    this.queueSync(id);
   };
   this.bindTheme = () => {
    const jq = window.jQuery_T4NT;
    if (typeof jq !== 'function' || this.themeBound) return;
    this.themeJQuery = jq;
    jq(this.section).on('variant:changed.melokeaAmazon', this.onThemeChange);
    this.themeBound = true;
    this.dataset.themeEventsReady = 'true';
   };
   this.onReady = () => { this.bindTheme(); this.queueSync(); };
   this.onPageShow = (event) => {
    if (!event.persisted) return;
    this.navigating = false;
    window.clearTimeout(this.syncTimer);
    this.syncTimer = null;
    this.connectionVersion += 1;
    this.syncQueued = false;
    this.pendingVariantId = null;
    this.bindTheme();
   };
   this.section.addEventListener('change', this.onChange, true);
   this.section.addEventListener('click', this.onSwatchClick, true);
   this.dataset.eventsReady = 'v3';
   this.onReady();
   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
   window.addEventListener('load', this.onReady, { once: true });
   window.addEventListener('pageshow', this.onPageShow);
  }
  disconnectedCallback() {
   this.eventsConnected = false;
   this.navigating = false;
   window.clearTimeout(this.syncTimer);
   this.syncTimer = null;
   this.connectionVersion = (this.connectionVersion || 0) + 1;
   this.syncQueued = false;
   this.pendingVariantId = null;
   this.section?.removeEventListener('change', this.onChange, true);
   this.section?.removeEventListener('click', this.onSwatchClick, true);
   document.removeEventListener('DOMContentLoaded', this.onReady);
   window.removeEventListener('load', this.onReady);
   window.removeEventListener('pageshow', this.onPageShow);
   if (this.themeBound) this.themeJQuery(this.section).off('variant:changed.melokeaAmazon', this.onThemeChange);
   this.themeBound = false;
   this.themeJQuery = null;
   delete this.dataset.eventsReady;
   delete this.dataset.themeEventsReady;
  }
  select(id) {
   id = String(id || '');
   if (this.navigating || !/^\d+$/.test(id) || id === this.dataset.selected) return;
   const template = this.querySelector(`template[data-amazon-variant="${id}"]`);
   const source = template?.content;
   const currentGallery = this.querySelector('[data-amazon-gallery] melokea-f078-gallery');
   const nextGallery = source?.querySelector('[data-gallery] melokea-f078-gallery');
   const nextCopy = source?.querySelector('[data-copy]');
   const nextShort = source?.querySelector('[data-short]');
   if (!currentGallery || !nextGallery?.querySelector('.mk-f078-hero img') || !nextCopy?.textContent?.trim() || !nextShort?.textContent?.trim()) {
    const current = new URL(window.location.href);
    const target = new URL(current.href);
    target.searchParams.set('variant', id);
    this.navigating = true;
    this.dataset.fallbackVariant = id;
    this.dataset.fallbackNavigation = target.href === current.href ? 'reload' : 'assign';
    this.dataset.fallbackHref = target.href;
    if (target.href === current.href) window.location.reload();
    else window.location.assign(target.href);
    return;
   }
   currentGallery.replaceWith(nextGallery.cloneNode(true));
   for (const [target, origin] of [['copy','copy'],['short','short']]) {
    for (const el of document.querySelectorAll(`[data-amazon-${target}="${this.dataset.product}"]`)) {
     el.innerHTML = source.querySelector(`[data-${origin}]`).innerHTML;
    }
   }
   const title = this.dataset.title?.trim() || this.section.querySelector('h1')?.textContent?.trim();
   if (title) {
    this.section.querySelector('h1').textContent = title;
    document.querySelectorAll('.t4s-sticky-atc__title').forEach(el => el.textContent = title);
    document.title = /MELOKEA/i.test(title) ? title : title + ' – MELOKEA';
    document.querySelectorAll('meta[property="og:title"],meta[name="twitter:title"]').forEach(el => el.content = title);
   }
   const description = source.querySelector('.mk-product-summary')?.textContent?.trim();
   if (description) document.querySelectorAll('meta[name="description"],meta[property="og:description"],meta[name="twitter:description"]').forEach(el => el.content = description.slice(0,300));
   const image = source.querySelector('[data-f078-image]')?.dataset.f078Image;
   if (image) document.querySelectorAll('meta[property="og:image"],meta[property="og:image:secure_url"]').forEach(el => el.content = image);
   for (const schema of source.querySelectorAll('script[data-amazon-schema]')) {
    const current = document.getElementById(schema.id);
    if (current) current.textContent = schema.textContent;
   }
   this.dataset.selected = id;
  }
 });
}
